module.exports = __webpack_public_path__ + "static/media/rocket.b199c295.svg";